import { Link } from "react-router";
import type { EchoflicksVideoSession } from "../types";
import { RemakesPreviewCard } from "./RemakesPreviewCard";

export function RemakeWatchView({
  record,
  remakeId,
}: {
  record: EchoflicksVideoSession;
  remakeId: string;
}) {
  return (
    <div className="space-y-4">
      <h2 className="text-xl font-semibold">
        {record.movie_title || "Echo"}: remake
      </h2>
      <p className="text-sm text-muted-foreground">
        Watch this replacement video. The original Echo is available separately.
      </p>
      <Link
        className="text-sm underline"
        to={`/echoflicks_echoes/${encodeURIComponent(record.id)}/show`}
      >
        View original Echo
      </Link>
      <RemakesPreviewCard record={record} selectedRemakeId={remakeId} />
    </div>
  );
}
